const getNumberStyle = (number) => {
  // Skip styling if this is Hào Động
  if (number === 5) {
    return {};
  }

  const num = parseInt(number);
  if ([11, 13, 14, 19, 16, 12, 17, 18, 22, 31, 41, 91, 61, 21, 71, 81, 88, 68, 67, 78, 74, 96, 98, 97, 99, 86, 76, 87, 47, 69, 89, 79].includes(num)) {
    return { backgroundColor: "#fffe0a", color: "#ea4236" };
  } else if (String(number).includes('5') && !String(number).includes('0')) {
    return { backgroundColor: "#fffe0a", color: "#ea4236" };
  } else if (String(number).includes('0')) {
    return { backgroundColor: "#ea4236", color: "#111527" };
  }
  return {};
};

export default getNumberStyle;
